// removed by extract-text-webpack-plugin
module.exports = {"chartWrapper":"chartWrapper_251","overviewContainer":"overviewContainer_27L","overviewHeading":"overviewHeading_qJW","opacityIn":"opacityIn_2WV","overviewHeadingLeaving":"overviewHeadingLeaving_2KY","opacityOut":"opacityOut_XX6","backgroundFadeIn":"backgroundFadeIn_Vmt","backgroundFadeOut":"backgroundFadeOut_23R","scaleIn":"scaleIn_Cmt","scaleOut":"scaleOut_2_U"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/overview-page/overview-page.scss
// module id = 476
// module chunks = 0 1